export default "__VITE_ASSET__CtjSuBT0__"